module.exports = __webpack_public_path__ + "static/img/product12.28d6aa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product12.png
// module id = JCIe
// module chunks = 10